import {useThemeColors} from '@nfq/colors';

/**
 * The `useFeatures` hook retrieves the current theme color palette for use within the Features block component.
 * It provides a centralized access point to theme-aware colors, ensuring consistent styling across all elements rendered in the Features section.
 * This hook encapsulates the color retrieval logic so the component remains focused on layout and rendering concerns.
 *
 * @returns An object containing `colors` with the current theme color palette for styling the Features block.
 *
 * @example
 * ```tsx
 * const {colors} = useFeatures();
 * ```
 */
export const useFeatures = () => {
    const colors = useThemeColors();

    return {colors};
};